interface CaraMarkProps {
  className?: string;
}

export function CaraMark({ className = '' }: CaraMarkProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 256 256"
      role="img"
      aria-label="Cara"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46 30h108v72H94v124L46 178V30Z"
        fill="#19A9E5"
        stroke="#061026"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M102 178h60V82l48 48v96H102v-48Z"
        fill="#19A9E5"
        stroke="#061026"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
